/*
 * Copyright (c) Nexign, JSC, 2019-2023.
 */
/**
 *
 *
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @author Andrey Dubov
 * @version 1.23.0
 * @since 1.0.0
 */

import styled from 'styled-components';

import type { TOverflow, TTextAlign } from '@/main/types/globalTypes';
import { ScrollbarStyled } from '@components/common/Scrollbar/ScrollbarStyled';
import { colors, fonts } from '@theme/index';

export const TooltipContainerStyled = styled.div.attrs({
    className: 'tooltip__container',
})<{ maxWidth: string; maxHeight?: string; overflow?: TOverflow }>`
    display: flex;
    max-width: ${(props) => props.maxWidth};
    flex-direction: column;
    flex-wrap: nowrap;
    overflow: hidden;

    & .tooltip__msg {
        margin-top: 4px;
        max-height: ${(props) => props.maxHeight || '92px'};
    }

    span {
        overflow: ${(props) => props.overflow ?? 'hidden'};
        text-overflow: ellipsis;
        max-height: ${(props) => props.maxHeight || 'max-content'};
        padding-right: ${(props) => (props.overflow === 'auto' ? '5px' : 0)};
        overflow-wrap: break-word;
        ${ScrollbarStyled};

        &::-webkit-scrollbar {
            width: 8px;
        }
    }
`;

interface ITooltipTitleStyled {
    textAlign?: TTextAlign;
}

export const TooltipTitleStyled = styled.span.attrs({
    className: 'tooltip__title',
})<ITooltipTitleStyled>`
    ${fonts.textMain};
    color: ${colors.tooltipTextColor};
    white-space: pre-line;
    text-align: ${(props) => (props.textAlign ? props.textAlign : 'left')};

    .inquiry-link__button {
        margin-left: 0.3em;
    }
`;

export const TooltipMessageStyled = styled.span.attrs({
    className: 'tooltip__msg',
})`
    ${fonts.textMain};
    color: ${colors.tooltipTextColorSecondary};
`;

export const TooltipHintMessageStyled = styled.span.attrs({
    className: 'tooltip__hint-msg',
})`
    ${fonts.textMain};
    color: ${colors.tooltipTextColorSecondary};
`;
